export enum Error {
  OBJECT_ATRIBUTE_REQ_PARAM_REQUIRED = "OBJECT_ATRIBUTE_REQ_PARAM_REQUIRED",
  REGISTRY_PART_CLOSED = "registry-part-closed",
  NUMBER_NOT_FOUND = "number-not-found",
  CADASTRAL_CODE_NOT_FOUND_OR_CLOSED = "cadastral-code-not-found-or-closed",
  CADASTRAL_CODE_IN_REGISTRY = "cadastral-code-in-registry",
  CADASTRAL_CODE_IN_REGISTRY_MULTIPLE = "cadastral-code-in-registry-multiple",
}
